"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalLicenceUK = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const __1 = require("../../../../..");
const RadioQuestion_1 = require("../../../../components/input/radio/RadioQuestion");
const Spacer_1 = require("../../../../components/spacer/Spacer");
const FormInput_1 = require("../../../../components/input/text/FormInput");
const Checkbox_1 = require("../../../../components/input/checkbox/Checkbox");
const Label_1 = require("../../../../components/input/label/Label");
const FlexWrapper = styled_1.default.div `
	color: ${merlin_theme_1.default.colours.neutral.black};
	display: flex;
	justify-content: space-between;
	align-items: center;

	label {
		padding: 0;
		font-weight: 400;
		font-size: 1rem;
		line-height: 1.25rem;
		color: ${merlin_theme_1.default.colours.neutral.dark};
	}
`;
const CheckboxWrapper = styled_1.default.div `
	padding-right: 20px;
	margin-right: 20px;
	border-right: 1px solid ${merlin_theme_1.default.colours.neutral.light};
`;
const LocalLicenceUK = (props) => {
    var _a, _b;
    const { property, update } = props;
    const localLicence = ((_a = property.local_licence) !== null && _a !== void 0 ? _a : {});
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    const { entityActions } = React.useContext(__1.AppContext);
    const [propertyLocation, setPropertyLocation] = React.useState(localLicence.uk_property_location);
    return (React.createElement(React.Fragment, null,
        React.createElement(Spacer_1.Spacer, { spacing: "standard" }),
        React.createElement(RadioQuestion_1.RadioQuestion, { selected: localLicence.uk_property_location, id: "uk_location", label: "Is your property located in Scotland?\t", question: "", options: {
                'Yes': 'scotland',
                'No': 'elsewhere',
            }, onChange: (_, v) => { setPropertyLocation(v); update({ local_licence: Object.assign(Object.assign({}, localLicence), { uk_property_location: v }) }); } }),
        propertyLocation === 'scotland' ? React.createElement(React.Fragment, null,
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(FormInput_1.FormInput, { label: "Licence number", hintText: "In Scotland, it is a legal requirement for all new hosts and existing hosts (from October 1st, 2023) to obtain a short-term lets license before accepting any bookings. If you already have your license number, please provide it here.", id: "uk_generic_tourist_licence_number", value: localLicence.uk_generic_tourist_licence_number, onChange: (e) => update({ local_licence: Object.assign(Object.assign({}, localLicence), { uk_generic_tourist_licence_number: e.target.value }) }) }),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(FlexWrapper, null,
                React.createElement(CheckboxWrapper, null,
                    React.createElement(Checkbox_1.Checkbox, { name: "uk_generic_compliance_agreement", onChange: (_, v) => update({ local_licence: Object.assign(Object.assign({}, localLicence), { uk_generic_compliance_agreement: v }) }), checked: (_b = localLicence.uk_generic_compliance_agreement) !== null && _b !== void 0 ? _b : false })),
                React.createElement(Label_1.Label, { htmlFor: `uk_generic_compliance_agreement` }, "I acknowledge that it is my responsibility to understand and comply with any laws, rules, and regulations that apply to my property. I certify that I will adhere to all applicable laws and regulations."))) : null,
        propertyLocation === 'elsewhere' ? React.createElement(React.Fragment, null,
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement("p", null, "If applicable, please ensure that you comply with any local laws or requirements"),
            React.createElement(Spacer_1.Spacer, { spacing: "small" }),
            React.createElement("p", null, "It is your responsibility to understand and comply with any laws, rules, or regulations that apply to your property."))
            : null));
};
exports.LocalLicenceUK = LocalLicenceUK;
//# sourceMappingURL=UK.js.map